import React from 'react'
import { getCurrentSubCategory } from 'SRC/modules/categories/selectors'
import { connect } from 'react-redux'

import { useFormikContext } from 'formik'

import { SelectDropdown, Wrapper } from 'SRC/ui/FormElementsNew'

const adTypes = [
	{
		id: 'buy',
		label: 'Kupujem',
		value: 'buy'
	},
	{
		id: 'sell',
		label: 'Prodajem',
		value: 'sell'
	},
]


const AdType = ({ category }) => {
	const formik = useFormikContext()

	if (!category || !category.canBuy) return null

	let selectedAdType = adTypes[1]

	if (formik.values.isBuying) selectedAdType = adTypes[0]

  return (
    <Wrapper>
      <SelectDropdown
        id='ad-type'
        title={category.buyFieldName || 'Tip Oglasa'}
        options={adTypes}
				isOptional={false}
				isRequired
        onChange={adTypeSelected => {
          console.log('adTypeSelected', adTypeSelected)
          let value = false

					if (adTypeSelected === 'buy') value = true

					formik.setFieldValue('isBuying', value)

          /**
           * Update specs
           */
					formik.setFieldValue('specifications', [
						...formik.values.specifications.map(formSpec => ({ ...formSpec, isBuyingAd: value }))
					])

          // /**
					//  * Update brand and product
					//  */
          if (formik.values.brand === null && !value) formik.setFieldValue('brand', -1)
          if (formik.values.brand === -1 && value) formik.setFieldValue('brand', null)

          if (formik.values.product === null && !value) formik.setFieldValue('product', -1)
          if (formik.values.product === -1 && value) formik.setFieldValue('product', null)

        }}
        value={selectedAdType.value}
      />
    </Wrapper>
  )
}

const mapStateToProps = state => {
	return {
		category: getCurrentSubCategory(state)
	}
}

export default connect(mapStateToProps)(AdType)
